// extracted by mini-css-extract-plugin
export default {"titleRow":"Table_titleRow__B1UG-","titleColumn":"Table_titleColumn__GcBiz","row":"Table_row__Al3BA","cell":"Table_cell__9Q4U0","cellHovering":"Table_cellHovering__1yy9w"};